import { useSortable } from '@dnd-kit/react/sortable'
import { DotsSixVerticalIcon, PencilSimpleIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'
import type { CommunityEssentialModel } from '@/models'

import { ESSENTIAL_ICON_MAP, EXTERNAL_LINK_TYPES } from '../community-essentials.constants'
import { getEssentialHref } from '../community-essentials.utils'
import * as S from './essential-item.styled'

interface EssentialItemProps {
  item: CommunityEssentialModel
  index: number
  onEdit: (item: CommunityEssentialModel) => void
}

export const EssentialItem = ({ item, index, onEdit }: EssentialItemProps) => {
  const { ref } = useSortable({ id: `essential-${item.id}`, index })

  const IconComponent = ESSENTIAL_ICON_MAP[item.icon]
  const href = getEssentialHref(item.type, item.value)
  const isExternalLink = EXTERNAL_LINK_TYPES.includes(item.type)

  return (
    <S.Row ref={ref}>
      <S.DragHandle>
        <Icon icon={DotsSixVerticalIcon} size="1.6rem" />
      </S.DragHandle>
      {IconComponent && (
        <S.IconWrapper>
          <Icon icon={IconComponent} size="2rem" />
        </S.IconWrapper>
      )}
      <S.Name breakLines={1} size="text-small" weight="medium">
        {item.name}
      </S.Name>
      {href ? (
        <S.Value
          href={href}
          rel={isExternalLink ? 'noopener noreferrer' : undefined}
          target={isExternalLink ? '_blank' : undefined}
        >
          {item.value}
        </S.Value>
      ) : (
        <S.Value as="span">{item.value}</S.Value>
      )}
      <S.EditIcon onClick={() => onEdit(item)}>
        <Icon icon={PencilSimpleIcon} size="1.6rem" />
      </S.EditIcon>
    </S.Row>
  )
}
